<template>
  <div class="w-[300px] h-[375px] p-4 rounded-2xl sha ">
      <slot></slot>
  </div>
</template>



<script>
export default {

}
</script>

